<template>
  <div id="ekt-header" class="clearfix">
    <div class="logo">
      <CustImg
        height="28"
        width="28"
        :src="sysLogo"
        :defaultSrc="DEFAULT_LOGO"
      />
    </div>
    <div
      class="wincall-warp"
      id="PHONE_BAR"
      v-outside="() => this.handleOutside('#PHONE_BAR .select_group', 2)"
    ></div>
    <div class="right-area">
      <SearchWrapper :isMiniScreen="isMiniScreen"/>
      <!-- 置顶消息通知 -->
      <NavNotice
        :isMiniScreen="isMiniScreen"
        :notice="topNotice"
        @noticeClick="navNoticeClick"
        v-if="!hasPermissionNot(this.userInfo.roleActionList, 'no_show_notice')"
      />

      <!-- 导航栏菜单 -->
      <NavMenu :navMenu="navMenu" @menuClick="navMenuClick" />

      <!-- 个人中心 -->
      <template>
        <div
          class="avatar-warp"
          v-outside="() => this.handleOutside('centerRef', 1)"
        >
          <el-dropdown
            ref="centerRef"
            trigger="hover"
            @command="centerMenuClick"
          >
            <div class="el-dropdown-link">
              <CustImg
                class="user-avatar"
                :src="avatar"
                :defaultSrc="DEFAULT_AVATAR"
              />
              <div class="user-info">
                <div class="user-name ellipsis-inline">
                  {{ userInfo.userDisplayName }}
                </div>
                <div class="user-center ellipsis-inline">
                  {{ userInfo.deptName }}
                </div>
              </div>
              <i class="el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="el-dropdown-menu-box">
              <el-dropdown-item
                v-for="item in centerMenu"
                :key="item.id"
                :command="item"
                >{{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getNav, getTopNotice } from "@/api/index";
import { showConfimLogoutBox } from "@/assets/js/utils";
import mixins from "@/mixins";
import NavNotice from "./navNotice/index.vue";
import NavMenu from "./navMenu/index.vue";
import SearchWrapper from "./SearchWrapper";
import { cookie } from "@/utils"

export default {
  name: "Header",
  mixins: [mixins],
  components: {
    NavNotice,
    NavMenu,
    SearchWrapper
  },
  data() {
    return {
      // 默认logo
      DEFAULT_LOGO: this._config.DEFAULT_LOGO,
      // 默认头像
      DEFAULT_AVATAR: this._config.DEFAULT_AVATAR,
      isMiniScreen: false,
      // 置顶通知
      noticeTimer: null,
      topNotice: [],
      // 导航菜单
      navMenu: [],

      // 用户中心下拉
      centerMenu: [
        { label: this.$t('home.personalSetting'), type: "Setting" },
        { label: this.$t('home.resetPassword'), type: "ResetPwd" },
        { label: this.$t('home.logout'), type: "Logout" },
      ],

      currentStatus: {
        icon: "icon-dialog",
        label: this.$t('common.online'),
        id: 1,
      },
      // 状态
      statusList: [
        {
          icon: "icon-dialog",
          label: this.$t('common.online'),
          id: 1,
        },
        {
          icon: "icon-state-busy",
          label: this.$t('common.offline'),
          id: 2,
        },
      ],

      userNoticeNum: 10,
      warningNum: 5,
      // 加入提醒
      noticeVisible: false,
      noticeForm: {
        date: "",
        time: "",
        content: "",
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    sysLogo() {
      const { vcc: { systemLogo = "" } = {} } = this.userInfo || {};
      return systemLogo || this.DEFAULT_LOGO;
    },
    avatar() {
      return this.userInfo.avatar || this.default_avatar;
    },
  },
  created() {
    this.getNavMenu();
    this.getTopNotice();
    this.noticeTimer = setInterval(() => {
      this.getTopNotice();
    }, this._config.NOTICE_REFRESH_TIME);
  },
  mounted() {
    const { MINI_SCREEN = 1600 } = this._config;
    if (document.body.clientWidth < MINI_SCREEN) {
      this.isMiniScreen = true;
    }
    window.addEventListener("resize", () => {
      if (document.body.clientWidth < MINI_SCREEN) {
        this.isMiniScreen = true;
      } else {
        this.isMiniScreen = false;
      }
    });
  },
  methods: {
    ...mapActions(["changeDrawerInfo", "addTab", "changeFloatBarMenu"]),
    /**
     * 功能：查询导航栏菜单集合
     */
    getNavMenu() {
      getNav()
        .then((res) => {
          const { code = 0, data = [], message } = res;
          if (code == 0) {
            let allMenu = data.sort((a, b) => {
              return a.sort - b.sort;
            });
            let floatBarMenu = allMenu.filter((item) => item.type == "floatbar");
            this.navMenu = allMenu.filter((item) => item.type != "floatbar");
            this.changeFloatBarMenu(floatBarMenu)
          } else {
            this.navMenu = [];
            console.log(this.$t('home.queryNavMenuError'), code, message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * 功能：查询置顶通知集合
     */
    getTopNotice() {
      getTopNotice({ flag: 2 })
        .then((res) => {
          const { code = 0, data = [], message } = res;
          if (code == 0) {
            this.topNotice = data;
          } else {
            console.log(this.$t('home.queryTopNoticeError'), code, message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * 功能：通知点击响应事件
     */
    navNoticeClick(noticeInfo) {
      const {
        my: { ektv3_page },
      } = this._config.URL;
      this.changeDrawerInfo({
        title: this.$t('home.announcementDetail'),
        drawerShow: true,
        drawerSrc: `${ektv3_page}/ekt/announce/details`,
        drawerWidth: 600,
      });
    },
    /**
     * 功能：导航菜单点击事件
     * item：当前菜单参数
     */
    navMenuClick(menuInfo) {
      const {
        name,
        icon,
        onclick: { action, url, width, options = undefined },
      } = menuInfo;
      console.log(width, menuInfo, "navMenuClick");
      switch (action) {
        // tab打开
        case "openTab":
          let tabItem = {
            key: String(name),
            name: name,
            url: url,
            icon: icon,
          };
          this.addTab(tabItem);
          break;
        // 新浏览器窗口打开
        case "openBlank":
          window.open(url, "_target");
          break;
        // 全局抽屉打开
        case "openDrawer":
          this.changeDrawerInfo({
            title: name,
            drawerShow: true,
            drawerSrc: url,
            drawerWidth: width || "30%",
            options: options,
          });
          break;

        default:
          break;
      }
    },
    /**
     * 功能：个人中心下拉菜单事件
     */
    centerMenuClick(menuInfo) {
      const { type } = menuInfo || {};
      const { my: { ektv3_page = "//ektv3-test.icsoc.net" } = {} } =
        this._config.URL || {};
      let tabItem = {};
      switch (type) {
        case "Setting":
          tabItem = {
            key: this.$t('home.personalSetting'),
            name: this.$t('home.personalSetting'),
            url: `${ektv3_page}/ekt/personalSettings`,
          };
          ektv3_page && this.addTab(tabItem);
          break;
        case "ResetPwd":
          tabItem = {
            key: this.$t('qidian.modifyPassword'),
            name: this.$t('qidian.modifyPassword'),
            url: `${ektv3_page}/ekt/changePassword`,
          };
          ektv3_page && this.addTab(tabItem);
          break;
        case "Logout":
          cookie.setCookie('trc_ag_status', 'offline')
          showConfimLogoutBox();
          break;
        default:
          break;
      }
    },
  },
  destroyed() {
    this.noticeTimer && clearInterval(this.noticeTimer);
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/view/Home/header/index.vue